"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  en: {
    clearButtonAccessibilityLabel: 'Clear',
    showPasswordAccessibilityLabel: 'Show Password',
    hidePasswordAccessibilityLabel: 'Hide Password'
  },
  fr: {
    clearButtonAccessibilityLabel: 'Effacer',
    showPasswordAccessibilityLabel: 'montrer le mot de passe',
    hidePasswordAccessibilityLabel: 'masquer le mot de passe'
  }
};